// @flow
import DateField from '.'
import { wrapWithField } from '../Field'

export default wrapWithField(DateField)
